// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 954) return "subsite-china/954-a017000b9c93e5954603.js";
	if (chunkId === 532) return "subsite-china/styles-4eaeceb620afdd1ebc91.js";
	if (chunkId === 875) return "subsite-china/190f48e1d712abf1b23afe7d98d0424ba15cabee-4ad9302ad7a0a97b4c8b.js";
	if (chunkId === 218) return "subsite-china/component---src-pages-404-tsx-9426f5078a4f3b305157.js";
	if (chunkId === 278) return "subsite-china/b0c88c5e5b54854a066ab8be45f25781c5307858-2e23edce2fb80b943046.js";
	if (chunkId === 904) return "subsite-china/2d1c9d34d7cabdcdf27eb8ffad16bade3b93f9b1-638cd9ac6ef97d47e6f7.js";
	if (chunkId === 660) return "subsite-china/component---src-templates-personal-area-calendar-page-index-tsx-2fad66a1ec7f2cc5a299.js";
	if (chunkId === 456) return "subsite-china/8bd7444894d603c816394f87921cda61ce72b74b-9fa08c659138a3028b44.js";
	if (chunkId === 874) return "subsite-china/component---src-templates-personal-area-profile-page-index-tsx-3967277e5624ca063979.js";
	if (chunkId === 868) return "subsite-china/component---src-templates-qr-redirect-tsx-e4ae888334e165097a3a.js";
	if (chunkId === 77) return "subsite-china/component---src-templates-search-page-index-tsx-662ee108a8f6acc66a86.js";
	if (chunkId === 737) return "subsite-china/fb7d5399-93dce5fc90ef5c7664ed.js";
	if (chunkId === 863) return "subsite-china/072d4843-b5a12bc6e97b45501615.js";
	if (chunkId === 208) return "subsite-china/2aacc723-e0a837027cb46371ba7e.js";
	if (chunkId === 344) return "subsite-china/bf322c48-e55fc740cc153cf603f6.js";
	if (chunkId === 811) return "subsite-china/22e32791-a66f54a1922ec0bc7847.js";
	if (chunkId === 312) return "subsite-china/409a021e-fb9bda0ed46e4567ac8b.js";
	if (chunkId === 125) return "subsite-china/b2d36f25-ce31179abdf90ca96a7d.js";
	if (chunkId === 255) return "subsite-china/7d0bf13e-a7dd780e5a7c8a5f9bf0.js";
	if (chunkId === 330) return "subsite-china/component---src-templates-standard-page-index-tsx-ba7c8270d8c0cf0e6358.js";
	if (chunkId === 731) return "subsite-china/731-e70316a10c888072c8d7.js";
	if (chunkId === 843) return "subsite-china/843-3cf7be2998fc151be0f3.js";
	// return url for filenames based on template
	return undefined;
};